const styles = ({ typography }) => ({
  container: {
    padding: `${typography.pxToRem(16)} 0`,
  },
});

export default styles;
